import { defineMessages } from '@cookbook/solid-intl'

export const messages = defineMessages({
    backAriaLabel: {
        defaultMessage: 'Back',
        id: 'ModalOrganismComponent.backAriaLabel',
    },
})
